import { configureStore } from '@reduxjs/toolkit';
import { psapInfoListener } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoMiddleware';
import { rsosApi } from '@rsos/reduxDataStore/src/features/rsosApi';
import reducer from '../reducers';

// The consolidated admin app intentionally does NOT persist or rehydrate Redux
// state. Every section fetches its own data on mount behind an AppLoading gate,
// so rehydrating slices from a previous session only caused bugs: most notably
// a section's `initialized` flag rehydrating true before the current session
// had fetched the data that section renders (e.g. navigating to Access from a
// different admin page rendered UsersManagement against empty sinatra
// management). Auth is unaffected — tokens live in localStorage (see
// shared/sinatra/src/utils/tokens.js), not in persisted Redux state.
//
// This app therefore has no redux-persist Persistor: the shared logout helpers
// (onLogout, reached via ErrorPage and onSAMLrequest) accept an optional
// persistor and simply skip the flush when there is none to flush.
export const store = configureStore({
  reducer,
  // getDefaultMiddleware already includes redux-thunk; rsosApi powers the
  // RTK Query endpoints the communication section uses, and psapInfoListener
  // configures phone utils when the active PSAP changes.
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      rsosApi.middleware,
      psapInfoListener.middleware,
    ),
});
export type AdminDispatch = typeof store.dispatch;
